// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3xgZr","header":"ReportDetails_header__4oKoB","title":"ReportDetails_title__2Chbw","left":"ReportDetails_left__2G2Z0"};